import { getUserInfo } from "../../webUXApi/userInfoApi";
// Expose user info APIs
export class WidgetUserInfo {
    async getUserInfo() {
        const userInfo = await getUserInfo();
        if (!userInfo) {
            return {};
        }
        return userInfo;
    }
}
